import { useQuery } from "@tanstack/react-query";
import { API_ENDPOINTS, ApiConfigs, KeyQueryApi } from "../config/apiConfig";
import { categoriesData } from "../services/categoriesData";
import { PostTypeKey } from "../types/common.type";
import apiClient from "../services/api/apiClient";

export const fetchCategories = async (type: string) => {
  const response:any=apiClient.get(`${API_ENDPOINTS.CATEGORY}${type}/categories/`);
  return response
};
export const useCategories = (type:PostTypeKey) => {
  const {data} = useQuery<any>({
    queryKey: [`${KeyQueryApi.GET_CATEGORIES}_${type}`, ApiConfigs.baseURL],
    queryFn: () => fetchCategories(type), // No need to pass language
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
  console.log({data});
  
  return {
    data:data?.data||[],
  };
};